const contentAutoUI = {
    default: {
      fields: ["name_flow", "link_connect", "time_setting", "person_receive_noti", "message_noti_new_ticket", "person_confirm"],
    },
  };
  
  export default contentAutoUI;
  